import { VIDEO_TILE_WIDTH } from '@/components/VideoTile';
import styled from '@emotion/styled';
import { ButtonBase } from '@mui/material';

export const WorkspaceSectionContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%;
`;

export const WorkspaceTileList = styled.div<{ tileWidthPx?: number }>`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(${({ tileWidthPx = VIDEO_TILE_WIDTH }) => tileWidthPx}px, 1fr));
    grid-row: 1; /* Ensure each row takes up equal height */
    grid-gap: 24px;
    overflow: hidden;
    justify-content: space-between;

    grid-template-rows: repeat(1, 1fr);
    grid-auto-rows: 0; /* set height to 0 for autogenerated grid rows */
`;

export const WorkspaceSectionHeader = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
`;

export const WorkspaceSectionHeaderButton = styled(ButtonBase)`
    color: ${({ theme }) => theme.colors.black[500]};
    font-size: 14px;
    font-weight: 600;
    letter-spacing: -0.28px;

    :hover {
        color: ${({ theme }) => theme.colors.black[900]};
    }
`;
